import Settings from '../Settings';

// ── Legacy / outer-tab ID → Settings.jsx inner tab ID ────────────────────────
// Covers:
//   • Old SettingsShell outer tabs (general, team, payments, messaging,
//     integrations, ai, webhooks)
//   • AccountDropdown deep-links (user-profile, appearance, …)
//   • Any direct Settings.jsx tab ID passes through unchanged via the fallback
const SETTINGS_TAB_MAP = {
  // Old SettingsShell outer tabs
  general:      'user-profile',
  team:         'users',
  payments:     'payments',
  messaging:    'messaging',
  integrations: 'integrations',
  ai:           'ai-metering',
  webhooks:     'webhooks',
};

/**
 * SettingsShell
 *
 * Thin resolver that maps any incoming `initialTab` value (legacy outer-tab
 * keys, AccountDropdown deep-link IDs, or direct Settings.jsx tab IDs) to the
 * correct Settings.jsx page, then renders Settings directly.
 *
 * Navigation within Settings is handled by Settings.jsx's own left-sidebar
 * NAV_GROUPS (restructured to 6 groups per the Phase-19 spec).  No outer
 * tab bar needed here — Settings.jsx is the single source of navigation truth.
 */
export default function SettingsShell({ initialTab = 'user-profile' }) {
  const resolvedTab = SETTINGS_TAB_MAP[initialTab] ?? initialTab;
  return <Settings initialTab={resolvedTab} />;
}
